import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { MessagingService } from "../messaging/messaging.service";
import { SeverityType } from "../messaging/severity-type.enum";
import { HttpStatusCode } from "../meta/http-status-code.enum";

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  constructor(
    private messagingService: MessagingService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            // This is where you would handle logging, success response, etc
          }
        },
        error => {
          if (error instanceof HttpErrorResponse && this.isAvailableError(error)) {
            const message = StringHelper.clean(error.error);

            switch (error.status) {
              case HttpStatusCode.FailedLogin:
                this.messagingService.showMessage(message, SeverityType.ERROR, "loginMessage");
                break;
              case HttpStatusCode.ServiceUnavailable:
                this.messagingService.showMessage("Sorry for the brief interruption. Please try again.", SeverityType.ERROR);
                break;
              case HttpStatusCode.BrokenRule:
                this.messagingService.showMessage(message, SeverityType.ERROR);
                break;
              default:
                // log nothing
                break;
            }
          }
        }
      )
    );
  }

  isAvailableError({ error }: HttpErrorResponse): boolean {
    return StringHelper.isAvailable(error) && error !== "null";
  }
}
